import { actionWithLoader, downloadFile, onEnter, push } from "../Utils/utils"
import { getServerUrl } from "../../utils"
import { axiosCall } from "../../utils/axiosUtils"
import { loadProductionSubstitutions } from "../../parseManager/productionSubstitutions/parseProductionSubstitutionsManager"
import dayjs from "dayjs"
import { getRawMaterialSupplierItems } from "../../parseManager/suppliers/supplierItems/parseSupplierItemManager"
import Parse from "parse"
import { loadPSEByProductionDateAndSupplierItem } from "../../parseManager/productionStepExecutions/parseProductionStepExecutionManager"

export const showProductionSubstitutions = () => {
	return push("/productionSubstitutions")
}


export const loadProductionSubstitutionsData = () => {
	return async dispatch => {
		const [productionSubstitutions, supplierItems] = await Promise.all([
			loadProductionSubstitutions({
				filters: {},
				includes: ["originalSupplierItem", "replacementSupplierItem", "recipes"],
				selects: [],
				toJSON: true
			}),
			getRawMaterialSupplierItems({ select: ["name"] })
		])
		const supplierItemsOptions = supplierItems.map(supplierItem => ({
			key: supplierItem.objectId,
			value: supplierItem.name,
			label: supplierItem.name
		}))
		dispatch({
			type: "PRODUCTION_SUBSTITUTIONS_LOADED",
			productionSubstitutions
		})
		dispatch({
			type: "PRODUCTION_SUBSTITUTIONS_SUPPLIER_ITEMS_OPTIONS_LOADED",
			supplierItemsOptions
		})
	}
}

export const saveProductionSubstitution = (values, showSnackbar = true) => {
	return actionWithLoader(async (dispatch) => {
		try {
			const result = await Parse.Cloud.run("saveProductionSubstitution", {
				originalSupplierItemId: values.originalSupplierItem,
				replacementSupplierItemId: values.replacementSupplierItem,
				productionStepExecutionsIds: values.productionStepExecutions,
				recipesIds: values.recipes,
				startDate: values.startDate,
				endDate: values.endDate,
				usernameId: values.currentUserId
			})

			if (showSnackbar) {
				dispatch({
					type: "PRODUCTION_SUBSTITUTION_SNACKBAR_LOADED",
					snackbar: { 
						open: true, 
						type: result.success ? "success" : "error", 
						message: result.success ? `Le remplacement d’article a bien été programmé pour les productions du ${dayjs.utc(values.startDate).format("DD/MM/YYYY")} au ${dayjs.utc(values.endDate).format("DD/MM/YYYY")}.` : `Aucune production entre le ${dayjs.utc(values.startDate).format("DD/MM/YYYY")} et le ${dayjs.utc(values.endDate).format("DD/MM/YYYY")} n’a été trouvée ou ne contient l’article à remplacer.`, 
						duration: 5000 }
				})
			}
		}
		catch (e) {
			dispatch({
				type: "PRODUCTION_SUBSTITUTION_SNACKBAR_LOADED",
				snackbar: { open: true, type: "error", message: "Une erreur est survenue lors de la création de la substitution", duration: 5000 }
			})
		}
	})
}

export const saveFutureProductionSubstitution = (values) => {
	return actionWithLoader(async (dispatch) => {
		const startDay = dayjs(values.startDate).utc().startOf("day").valueOf()
		const endDay = dayjs(values.endDate).utc().endOf("day").valueOf()

		const productionStepExecutions = await loadPSEByProductionDateAndSupplierItem({
			supplierItemId: values.originalSupplierItem,
			startProductionDate: startDay,
			endProductionDate: endDay
		})

		const formattedValues = {
			...values,
			startDate: startDay,
			endDate: endDay,
			productionStepExecutions: productionStepExecutions.map(pse => pse.objectId)
		}

		dispatch(saveProductionSubstitution(formattedValues))
	})
}

/**
 * KFC-598: CSV of the recipes produced between two production days that contain the supplier item
 * @param {{supplierItem: {value: string, name: string}, startDate: string, endDate: string}} params production days as YYYY-MM-DD
 */
// KFC-622: detail "productionDay" (default) or "usageDay"
export const downloadSupplierItemRecipesCsv = ({ supplierItem, startDate, endDate, detail = "productionDay" }) => {
	return actionWithLoader(async (dispatch) => {
		try {
			const response = await axiosCall(
				"POST",
				`${getServerUrl()}/productionItems/_extractSupplierItemRecipes`,
				{ supplierItemId: supplierItem.value, startDate, endDate, detail },
				{ "Content-Type": "application/json" },
				"blob"
			)

			const detailSuffix = detail === "usageDay" ? " - par jour d’utilisation" : ""
			const fileName = `Productions contenant ${supplierItem.name} - prod du ${dayjs(startDate).format("DD-MM-YYYY")} au ${dayjs(endDate).format("DD-MM-YYYY")}${detailSuffix}.csv`
			downloadFile(window.URL.createObjectURL(response.data), fileName)
		}
		catch (e) {
			dispatch({
				type: "PRODUCTION_SUBSTITUTION_SNACKBAR_LOADED",
				snackbar: { open: true, type: "error", message: "Erreur lors de l’export des productions contenant l’article.", duration: 5000 }
			})
		}
	})
}

export const closeProductionSubstitutionSnackbar = (currentType) => {
	return actionWithLoader(async (dispatch) => {
		dispatch({
			type: "PRODUCTION_SUBSTITUTION_SNACKBAR_LOADED",
			snackbar: { open: false, type: currentType, message: "", duration: 1000 }
		})
	})
}


export const onEnterProductionSubstitutions = (store) => {
	return onEnter({
		store,
		actionThunk: loadProductionSubstitutionsData
	})
}


